if (!customElements.get("product-form")) {
	customElements.define(
		"product-form",
		class ProductForm extends HTMLElement {
			constructor() {
				super();

				this.form = this.querySelector("form");
				this.form.querySelector("[name=id]").disabled = false;
				this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
				this.cart = document.querySelector("cart-drawer");
				this.submitButton = this.querySelector('[type="submit"]');
				if (document.querySelector("cart-drawer"))
					this.submitButton.setAttribute("aria-haspopup", "dialog");

					this.hideErrors = this.dataset.hideErrors === "true";
			}

			onSubmitHandler(evt) {
				evt.preventDefault();
				if (this.submitButton.getAttribute("aria-disabled") === "true") return;

				this.handleErrorMessage();

				this.submitButton.setAttribute("aria-disabled", true);
				this.submitButton.classList.add("loading");
				//this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

				config = fetchConfig("javascript");
				config.headers["X-Requested-With"] = "XMLHttpRequest";
				delete config.headers["Content-Type"];

				const formData = new FormData(this.form);
				const cartSupportsDrawer =
					this.cart &&
					typeof this.cart.getSectionsToRender === "function" &&
					typeof this.cart.renderContents === "function";
				if (cartSupportsDrawer) {
					formData.append(
						"sections",
						this.cart.getSectionsToRender().map((section) => section.id)
					);
					formData.append("sections_url", window.location.pathname);
					if (typeof this.cart.setActiveElement === "function") {
						this.cart.setActiveElement(document.activeElement);
					}
				}
				config.body = formData;

				fetch(`${routes.cart_add_url}`, config)
					.then((response) => {
						// Check if response is ok before parsing
						if (!response.ok) {
							// For 401 errors, the body is usually empty
							if (response.status === 401) {
								return response.text().then(text => {
									throw new Error(`Unable to add product to cart. Please try again.`);
								});
							}
							// For other errors, try to get error message
							return response.text().then(text => {
								try {
									const errorData = JSON.parse(text);
									throw new Error(errorData.description || errorData.message || `Unable to add product to cart. Please try again.`);
								} catch (e) {
									if (e.message.includes('Unable to add')) throw e;
									throw new Error(`Unable to add product to cart. Please try again.`);
								}
							});
						}
						// Only parse as JSON if response is ok
						return response.json();
					})
					.then((response) => {
						// CART ERROR EVENT
						if (response.status) {
							document.dispatchEvent(
								new CustomEvent("cart:error", {
									detail: {
										source: this.dataset.source,
										productVariantId: formData.get("id"),
										errors: response.description,
										message: response.message
									}
								})
							);
							// -------------------------------------------
							publish(PUB_SUB_EVENTS.cartError, {
								source: "product-form",
								productVariantId: formData.get("id"),
								errors: response.description,
								message: response.message,
							});
							this.handleErrorMessage(response.description);

							const soldOutMessage =
								this.submitButton.querySelector(".sold-out-message");
							if (!soldOutMessage) return;
							this.submitButton.setAttribute("aria-disabled", true);
							this.submitButton.querySelector("span").classList.add("hidden");
							soldOutMessage.classList.remove("hidden");
							this.error = true;
							return;
						}

						// VARIANT ADDED EVENT
						document.dispatchEvent(
							new CustomEvent("variant:add", {
								detail: {
									variant: {
										id: formData.get("id"),
									},
									quantity: Number(formData.get("quantity") || 1),
									formElement: this.form,
									sectionId: this.dataset.source
								}
							})
						);
						// -------------------------------------------

						var cartJsUrl = (window.routes && window.routes.cart_url ? window.routes.cart_url : "/cart") + ".js";
						fetch(cartJsUrl)
							.then(function (res) {
								if (!res.ok) throw new Error("cart.js " + res.status);
								return res.json();
							})
							.then(
								function (parsedState) {
									document.dispatchEvent(
										new CustomEvent("cart:change", {
											detail: { cart: parsedState, sectionId: this.dataset.source }
										})
									);
									document.documentElement.dispatchEvent(new CustomEvent("cart:refresh"));
									if (!cartSupportsDrawer) {
										window.location = window.routes ? window.routes.cart_url : "/cart";
									}
								}.bind(this)
							)
							.catch(function (error) {
								console.error("Error fetching cart state:", error);
								if (!cartSupportsDrawer) {
									window.location = window.routes ? window.routes.cart_url : "/cart";
								}
							});

						if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, { source: "product-form", productVariantId: formData.get("id") });
						this.error = false;
						if (cartSupportsDrawer) {
							var quickAddModal = this.closest("quick-add-modal");
							if (quickAddModal) {
								document.body.addEventListener(
									"modalClosed",
									function () {
										setTimeout(
											function () {
												this.cart.renderContents(response);
											}.bind(this),
											0
										);
									}.bind(this),
									{ once: true }
								);
								quickAddModal.hide(true);
							} else {
								try {
									this.cart.renderContents(response);
								} catch (err) {
									console.warn("Cart drawer update failed:", err);
									if (this.cart.open) this.cart.open();
								}
							}
						}
					})
					.catch((e) => {
						console.error('Error adding to cart:', e);
						this.handleErrorMessage(e.message || 'Unable to add product to cart. Please try again.');
						this.error = true;
					})
					.finally(() => {
						this.submitButton.classList.remove("loading");
						if (this.cart && this.cart.classList.contains("is-empty"))
							this.cart.classList.remove("is-empty");
						if (!this.error) this.submitButton.removeAttribute("aria-disabled");
						//this.querySelector('.loading-overlay__spinner').classList.add('hidden');
					});
			}

			handleErrorMessage(errorMessage = false) {
				if (this.hideErrors) return;
				
				this.errorMessageWrapper =
					this.errorMessageWrapper ||
					this.querySelector(".product-form__error-message-wrapper");
				if (!this.errorMessageWrapper) return;
				this.errorMessage =
					this.errorMessage ||
					this.errorMessageWrapper.querySelector(
						".product-form__error-message"
					);

				this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

				if (errorMessage) {
					this.errorMessage.textContent = errorMessage;
				}
			}
		}
	);
}
